<script>
</script>

<div class="scrollable-table products-scrollable-table mt-25">
  <table style="margin-top: 0;">
    <thead>
      <tr class="flex flex-row align-center" style="padding-bottom: 0;">
        <th class="checkbox-table">
          <div class="checkbox-wrapper small">
            <input id="rowcbx0" class="css-checkbox select-cbx" type="checkbox" name="rowcbx0" />
            <label for="rowcbx0" class="css-label">&nbsp;</label>
          </div>
        </th>
        <th class="flex-1 mw-240">Category Name</th>
        <th class="flex-none mw-180">% of All Revenue</th>
        <th class="flex-none mw-140">Revenue</th>
      </tr>
    </thead>
    <tbody style="min-height: 400px;">
      <tr class="flex flex-row align-center" data-id="10">
        <td class="checkbox-table">
          <div class="checkbox-wrapper small">
            <input id="rowcbx10" class="css-checkbox select-cbx" type="checkbox" name="rowcbx10" /> <label for="rowcbx10" class="css-label">&nbsp;</label>
          </div>
        </td>
        <td class="flex-1 mw-240">Category Name</td>
        <td class="flex-none mw-180">46%</td>
        <td class="flex-none mw-140">$7,350.99</td>
      </tr>
      <tr class="flex flex-row align-center" data-id="10">
        <td class="checkbox-table">
          <div class="checkbox-wrapper small">
            <input id="rowcbx10" class="css-checkbox select-cbx" type="checkbox" name="rowcbx10" /> <label for="rowcbx10" class="css-label">&nbsp;</label>
          </div>
        </td>
        <td class="flex-1 mw-240">Category Name</td>
        <td class="flex-none mw-180">46%</td>
        <td class="flex-none mw-140">$7,350.99</td>
      </tr>
      <tr class="flex flex-row align-center" data-id="10">
        <td class="checkbox-table">
          <div class="checkbox-wrapper small">
            <input id="rowcbx10" class="css-checkbox select-cbx" type="checkbox" name="rowcbx10" /> <label for="rowcbx10" class="css-label">&nbsp;</label>
          </div>
        </td>
        <td class="flex-1 mw-240">Category Name</td>
        <td class="flex-none mw-180">46%</td>
        <td class="flex-none mw-140">$7,350.99</td>
      </tr>
    </tbody>
  </table>
</div>
